<div class="close-form feedback-form h-100">
    <div class="left-container">
        <div class="section-header">Select open trade by trade date</div>
        <div class="section-content">
            <div class="selection-block open-trade-container side-container">
                <p-select [options]="openTradesDropdown()" 
                *ngIf="!areOpenTradesLoading"
                [(ngModel)]="selectedTrade" 
                [disabled]="isFieldDisabled()"
                [filter]="true"
                filterPlaceholder="Search trades"
                optionLabel="description" 
                placeholder="Select an open trade"
                (onChange)="onTradeSelectionChange($event)"></p-select>
                <div class="loading-block" *ngIf="areOpenTradesLoading"><fa-icon  [icon]="faSpinner" class="spinner-icon fa-spin-pulse"></fa-icon></div>
     
            </div>
            <div class="divider"> <p-divider layout="vertical"></p-divider></div>
            <div class="column trade-details side-container">
                <div class="trade-detail"><div class="detail-title">Entry price:</div><div class="detail-value">{{ tradePrice() }}</div></div>
                <div class="trade-detail"><div class="detail-title">Direction:</div><div class="detail-value">{{ tradeDirection() }}</div></div>
                <div class="trade-detail"><div class="detail-title">Contract:</div><div class="detail-value">{{ tradeContract() }}</div></div>
                <div class="trade-detail"><div class="detail-title">Lots quantity:</div><div class="detail-value">{{ tradeLots() }}</div></div>
            </div>

        </div>
     
    </div>
  
    <div class="right-container">
        <!-- <div class="section-header"><span>Closing data for trade</span> <span>{{ tradeDate() }}</span></div> -->
        <div class="section-content">
          
            <div class="column column-2 ">
                <div class="date-picker-container control-container">
                    <label>Closing date</label>
                    <p-datepicker 
                      appendTo="body"
                      [(ngModel)]="closingDate" 
                      [showIcon]="true" 
                      [showOnFocus]="false" 
                      inputId="buttondisplay"
                      placeholder="Select closing date" 
                      [disabled]="isFieldDisabled()"
                      (onSelect)="onClosingDateChange($event)"/>
                </div>

                <div class="trade-price-input input-field">
                    <div class="label-and-input">
                        <label>Closing price</label>
                        <div class="input-container"><span>$</span><input 
                            [disabled]="isFieldDisabled()"
                            [ngClass]="{ 'invalid-input': tradePriceNotValid() }"
                            type="number" id="manual-predicted-price" 
                            [(ngModel)]="closingPrice" 
                            (input)=" validateClosingPrice($event)" 
                            (focusout)="storeClosingPriceValue($event)"   maxlength="12" size="3" /></div>
                    </div>
    
                    <small [ngClass]="{ 'visible': tradePriceNotValid() }">Must be a valid numeric value</small>
                    
                </div>
                <div class="selection-block radiobuttons-container">
                    <div class="label-container"><label>Closing reason</label></div>
                    <div class="radio-buttons-wrapper">
                        <div class="field-radiobutton">
                            <p-radioButton  [disabled]="isFieldDisabled()" name="option" value="profit_taking" [(ngModel)]="closingReasonModel" inputId="profit_taking" (ngModelChange)="onReasonChange()"/>
                            <label for="take_profit">Profit taking</label>
                        </div>
                      
                        <div class="field-radiobutton">
                            <p-radioButton  [disabled]="isFieldDisabled()" name="option" value="stop_loss" [(ngModel)]="closingReasonModel" inputId="stop_loss" (ngModelChange)="onReasonChange()"/>
                            <label for="stop_loss">Stop loss</label>
                        </div>

                    </div>
                        
                      
                </div>
            </div>
            <div class="column column-3 ">
                <div class="free-text">
                    <label>Additional commentary</label>
                    <textarea pInputTextarea  
                    [disabled]="isFieldDisabled()"
                    [(ngModel)]="freeText" 
                    (input)=" validateFreeText($event)"
                    (blur)="onFreeTextEntered()"  rows="7" cols="30" placeholder="Enter your comments here..."></textarea>
        
                </div>
            </div>
        </div>
    </div>
</div>
